export const getCopilotChatUserId = async (): Promise<string | null> => {
  try {
    
    const response = await fetch(`${process.env.NEXT_PUBLIC_FRONTEND_HOST}/p/acko-assist-v2/api/get-or-create-user/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      console.error(`Failed to get copilot user: ${response.status}`);
      return null;
    }

    const data = await response.json();

    return data.user.chatUserId;
  } catch (error: any) {
    console.error("Error fetching copilot chat user ID", error.message);
    return null;
  }
};